/**
 * AnomalyFeed — displays active critical/high anomaly alerts.
 */
import React from 'react';

const SEVERITY_META = {
  critical: { label: 'Critical', color: '#dc2626', bg: '#fef2f2', border: '#fca5a5', dot: '🔴' },
  high:     { label: 'High',     color: '#ea580c', bg: '#fff7ed', border: '#fed7aa', dot: '🟠' },
  medium:   { label: 'Medium',   color: '#d97706', bg: '#fffbeb', border: '#fde68a', dot: '🟡' },
  low:      { label: 'Low',      color: '#0284c7', bg: '#eff6ff', border: '#bfdbfe', dot: '🔵' },
};

export { SEVERITY_META };

export default function AnomalyFeed({ alerts }) {
  if (!alerts || alerts.length === 0) return null;
  return (
    <div className="ai__section">
      <div className="ai__section-title">🚨 Active Anomalies</div>
      <div className="ai__anomaly-list">
        {alerts.map((a, i) => {
          const meta = SEVERITY_META[a.severity] || SEVERITY_META.low;
          return (
            <div key={a.id || i} className="ai__anomaly-card"
              style={{ borderLeft: `4px solid ${meta.color}`, background: meta.bg }}>
              <div className="ai__anomaly-header">
                <span className="ai__anomaly-dot">{meta.dot}</span>
                <span className="ai__anomaly-title">{a.title}</span>
                <span className="ai__anomaly-badge" style={{ background: meta.color }}>{meta.label}</span>
              </div>
              <div className="ai__anomaly-body">{a.message}</div>
              {a.z != null && (
                <div className="ai__anomaly-z">
                  σ = {a.z.toFixed(2)} · baseline ${a.baseline != null ? Math.round(a.baseline).toLocaleString() : '—'}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
